export default "__VITE_ASSET__r5hy8ZMPkh$CnSqWqJSrpA__"